import {
  GET_ACTIONS,
  SET_ACTIONS,
  GET_ACTIONS_ERROR,
  RESET_ACTIONS
} from './types'

const initialState = {
  actions: [],
  isLoadingActions: false
}

const actionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIONS:
      return {
        ...state,
        isLoadingActions: true
      }
    case SET_ACTIONS:
      return {
        ...state,
        actions: action.payload.actions,
        isLoadingActions: false
      }
    case GET_ACTIONS_ERROR:
      return {
        ...state,
        isLoadingActions: false
      }
    case RESET_ACTIONS:
      return {
        ...state,
        actions: [],
        isLoadingActions: false
      }
    default:
      return state
  }
}

export default actionsReducer
